import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const CollapseButton = ({ collapsed, onClick }) => (
  <button onClick={onClick} className="btn btn-white">
    <i className={classnames('fas', { 'fa-chevron-down': collapsed, 'fa-chevron-up': !collapsed })} />
  </button>
);

CollapseButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  collapsed: PropTypes.bool,
};

CollapseButton.defaultProps = {
  collapsed: false,
};

export default CollapseButton;
